import React from 'react'
import { RealEstateDataPageComponentData } from 'types'
import { Col, Container, Row } from 'react-bootstrap'
import useQueryDevelopment from '@hooks/useQueryDevelopment'
import Image from '@components/Image'
import { getPhotos, getDescription } from '@helpers/helper.rendering'
//Helpers
const developmentAmenities = ({
  developmentID,
  global_data,
}: {
  developmentID: string
} & RealEstateDataPageComponentData) => {
  const { data: allDevelopmentData, isLoading } = useQueryDevelopment(
    developmentID,
    global_data.pageConfig.keys.tokko,
  )
  return (
    <section
      className="grid-text-1 p-y-config dev d-inline-block"
      id="Proyecto"
    >
      <Container
        // className="d-flex justify-content-between"
        className="d-flex flex-lg-row flex-column justify-content-between align-items-lg-center"
        fluid
      >
        <div className="mb-lg-0 mt-5 text-justify w-100 order-lg-1 order-2">
          {/* <img
          className={'' + (isLoading ? 'skeleton' : '')}
          src={
            getPhotos(allDevelopmentData?.photos).length > 0
              ? getPhotos(allDevelopmentData?.photos)[0]?.original
              : ''
          }
          alt={allDevelopmentData?.publication_title}
        /> */}
          <h2 className={isLoading ? 'skeleton' : '' + ' mb-5 '}>
            {allDevelopmentData?.name}
            <br />
            {allDevelopmentData?.publication_title}
          </h2>
          {allDevelopmentData &&
            getDescription(allDevelopmentData?.description, 9999)?.map((description, index) => (
              <p
                className={isLoading ? 'skeleton ' : '' + 'd-inline'}
                key={index}
              >
                {description}
                {index > 0 && <br />}
              </p>
            ))}
        </div>
        <img
          className={'ms-lg-5 order-1 order-lg-2' + (isLoading ? 'skeleton' : '')}
          src={
            getPhotos(allDevelopmentData?.photos).length > 0
              ? getPhotos(allDevelopmentData?.photos)[0]?.original
              : ''
          }
          alt={allDevelopmentData?.publication_title}
        />
      </Container>
    </section>
  )
}

export default developmentAmenities
